import Grid from "@mui/material/Grid2";

interface GridIndexProps {
  field: string;
  value: string | number | any;
  isScrollable?: boolean;
  fieldSize?: number;
  valueSize?: number;
}

function GridIndex({
  field,
  value,
  isScrollable,
  fieldSize = 3.5,
  valueSize = 8,
}: GridIndexProps) {
  return (
    <Grid container spacing={1} sx={{ marginBottom: "3px" }}>
      <Grid size={fieldSize}>
        <span>{field}</span>
      </Grid>
      <Grid size={0.5}>:</Grid>
      <Grid
        size={valueSize}
        className={isScrollable ? "remarks" : ""}
        data-testid="value-grid"
      >
        <strong
          className={`${
            ["Allergies", "Remarks"].includes(field) ? "setHtml" : ""
          }`}
        >
          {value}
        </strong>
      </Grid>
    </Grid>
  );
}

export default GridIndex;
